import { Badge, Button, createTheme, PasswordInput } from '@mantine/core';

import { breakpoints, colors, fontSize, spacings } from './theme';

const getButtonClassNames = (variant?: string, disabled?: boolean) => {
  const baseClasses =
    'h-11 px-4 py-2 font-medium tracking-wide transition-all duration-300 ease-in-out rounded-xs relative overflow-hidden';

  if (disabled) {
    return `${baseClasses} bg-gray-100 text-gray-1000 cursor-default opacity-50`;
  }

  switch (variant) {
    case 'filled':
      return `${baseClasses} bg-primary-600 text-white border-none hover:bg-primary-700 hover:-translate-y-0.5`;
    case 'outline':
      return `${baseClasses} bg-white text-secondary-600 border border-secondary-600 hover:border-primary-600 hover:text-primary-600 hover:-translate-y-0.5`;
    case 'white':
      return `${baseClasses} bg-white text-secondary-600 border-none hover:text-primary-600 hover:-translate-y-0.5`;
    case 'subtle':
      return `${baseClasses} hover:-translate-y-0.5`;
    default:
      return `${baseClasses}`;
  }
};

const button = Button.extend({
  defaultProps: {
    variant: 'filled',
    radius: 'xs',
    size: 'md',
    // Align icon vertically with text
    styles: { section: { marginBottom: 2, height: 18, width: 18 } },
  },
  classNames: (_, params) => ({
    root: getButtonClassNames(params.variant, params.disabled),
  }),
});

const badge = Badge.extend({
  // Avoid uppercase in badge
  defaultProps: { styles: { label: { textTransform: 'none' } } },
});

const passwordInput = PasswordInput.extend({
  defaultProps: {
    styles: {
      visibilityToggle: {
        color: 'var(--mantine-color-gray-3) !important',
        '&:hover': {
          color: 'var(--mantine-color-white) !important',
        },
      },
    },
  },
});

const mantineTheme = createTheme({
  colors,
  components: { Button: button, Badge: badge, PasswordInput: passwordInput },
  spacing: spacings,
  fontSizes: fontSize,
  breakpoints: breakpoints,
  primaryColor: 'primary',
  defaultRadius: 'xs',
  cursorType: 'pointer',
});

export type ColorsType = keyof typeof colors;

export default mantineTheme;
